import { useEffect, useState } from "react";
import { ReportInfo, ReportProps } from "../../../../types/types";
import "./../ReportCreationFormPages.css";
import Box from "@mui/material/Box";
import Grow from "@mui/material/Grow";
import Icon from "@mui/material/Icon";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import MenuItem from "@mui/material/MenuItem";
import { ArrayUtils } from "../../../../utils/arrayUtils";
import { Text } from "@mantine/core";
import { X } from "tabler-icons-react";
import { popNotification } from "../../../kpi/setup/notification/notificationUtils";
import { useAuth } from "../../../../providers/AuthProvider";
import { getUserList, getNameFromEmail } from "../../../../services/reportService";

const options = [
  { value: "query", label: "Query" },
  { value: "entity", label: "Entity" },
];

export function ReportDetailsFormPage(props: ReportProps) {
  const authContext = localStorage.getItem("authContext") && JSON.parse(localStorage.getItem("authContext") as string);
  const ReportInfo = props.reportInfo;
  var ShowHide = props.showHide;

  const [show, setShow] = useState<boolean>(ShowHide);
  const [option, setOptions] = useState(
    ReportInfo.type == null ? "query" : ReportInfo.type
  );
  const [owners, setOwners] = useState([
    { value: " ", label: "Select Owner Name" },
  ]);
  const [owner, setOwner] = useState(
    ReportInfo.owner == null ? " " : ReportInfo.owner
  );
  //const [defaultFetchLimit, setDefaultFetchLimit] = React.useState(ReportInfo.fetchLimit == null ? ReportInfo.fetchLimit = 20000 : ReportInfo.fetchLimit);
  ReportInfo.fetchLimit = 20000;
  ReportInfo.type = option;
  ReportInfo.name = ReportInfo.name ? ReportInfo.name : "";
  ReportInfo.id = ReportInfo.name ? ReportInfo.id : "";
  ReportInfo.description = ReportInfo.description ? ReportInfo.description : "";
  ReportInfo.owner = ReportInfo.owner ? ReportInfo.owner : "";
  ReportInfo.fileNameFormat = ReportInfo.fileNameFormat
    ? ReportInfo.fileNameFormat
    : "";
  ReportInfo.fileFormat = ReportInfo.fileFormat ? ReportInfo.fileFormat : "";
  ReportInfo.viewEditStatus = ReportInfo.viewEditStatus
    ? ReportInfo.viewEditStatus
    : "EDIT";

  const addShow = () => {
    if (!show) return "Show Advance Config";
    else {
      ShowHide = true;
      return "Hide Advance Config";
    }
  };

  // const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setOptions(event.target.value);
  // };

  const addReportName = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    props.setReportState((currentState) => ({
      ...currentState,
      reportInfo: {
        ...currentState.reportInfo,
        name: event.target.value as string,
        id: event.target.value as string
      },
      validationErrors: currentState.validationErrors.filter(
        (er) => er.property !== "report_name"
      ),
    }));
  };
  const addReportDescription = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    props.setReportState((currentState) => ({
      ...currentState,
      reportInfo: {
        ...currentState.reportInfo,
        description: event.target.value as string,
      },
      validationErrors: currentState.validationErrors.filter(
        (er) => er.property !== "report_description"
      ),
    }));
  };
  const addReportOwnerName = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setOwner(event.target.value);
    props.setReportState((currentState) => ({
      ...currentState,
      reportInfo: {
        ...currentState.reportInfo,
        owner: event.target.value as string,
      },
      validationErrors: currentState.validationErrors.filter(
        (er) => er.property !== "owner"
      ),
    }));
    // setDefaultReportImplementation(event.target.value as string);
  };

  const addReportType = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setOptions(event.target.value);
    // if (event.target.value == 'entity')
    //   ReportInfo.implementation = ''
    // else
    //   ReportInfo.implementation = ReportInfo.name
    props.setReportState((currentState) => ({
      ...currentState,
      reportInfo: {
        ...currentState.reportInfo,
        reportType: event.target.value as string,
      },
      validationErrors: currentState.validationErrors.filter(
        (er) => er.property !== "report_type"
      ),
    }));
  };
  const addfetchLimitImplementation = (event: {
    target: { value: React.SetStateAction<any> };
  }) => {
    props.setReportState((currentState) => ({
      ...currentState,
      reportInfo: {
        ...currentState.reportInfo,
        fetchLimit: event.target.value,
      },
      validationErrors: currentState.validationErrors.filter(
        (er) => er.property !== "fetch_limit"
      ),
    }));
    // if (event.target.value != 'query')
    //  setDefaultReportImplementation("")
  };

  const addFileNameFormat = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    props.setReportState((currentState) => ({
      ...currentState,
      reportInfo: {
        ...currentState.reportInfo,
        fileNameFormat: event.target.value as string,
      },
      validationErrors: currentState.validationErrors.filter(
        (er) => er.property !== "report_FileName_Format"
      ),
    }));
  };
  const addReportFileFormat = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    props.setReportState((currentState) => ({
      ...currentState,
      reportInfo: {
        ...currentState.reportInfo,
        fileFormat: event.target.value as string,
      },
      validationErrors: currentState.validationErrors.filter(
        (er) => er.property !== "report_File_Format"
      ),
    }));
  };

  const additonalInfo = (ReportInfo: ReportInfo) => (
    <div>
      <div className="form right-side input-div">
        {/* Report fetch limit */}

        <TextField
          label="Fetch Limit:"
          id="fetch_limit"
          placeholder="Enter Fetch Limit"
          value={ReportInfo.fetchLimit}
          onFocus={viewOnlyNotifucation}
          onChange={addfetchLimitImplementation}
          sx={{ m: 1, width: "75%" }}
          InputProps={{
            readOnly: props.reportInfo.viewEditStatus === "VIEW" ? true : false,
            startAdornment: <InputAdornment position="start"></InputAdornment>,
          }}
          // defaultValue={defaultFetchLimit}
          //  defaultValue={ReportInfo.fetchLimit == null ? ReportInfo.fetchLimit=defaultFetchLimit : ReportInfo.fetchLimit}
          helperText="Enter value if want to change fetch limit for records in Test download Report"
        />
        {fetchLimitError && <Text color="red">{fetchLimitError}</Text>}
      </div>

      {/* Report File Format */}

      <div className="form right-side input-div">
        <FormControl>
          <FormLabel id="demo-row-radio-buttons-group-label">
            File Format
          </FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            className="radiogp"
            onChange={addReportFileFormat}
            id="report_File_Format"
            defaultValue={
              ReportInfo.fileFormat === null || ReportInfo.fileFormat === ""
                ? (ReportInfo.fileFormat = "excel")
                : ReportInfo.fileFormat
            }
          >
            <FormControlLabel
              value="excel"
              control={<Radio />}
              label="excel"
              disabled={
                props.reportInfo.viewEditStatus === "VIEW" ? true : false
              }
            />
            <FormControlLabel
              value="csv"
              control={<Radio />}
              label="csv"
              disabled={
                props.reportInfo.viewEditStatus === "VIEW" ? true : false
              }
            />
            <FormControlLabel
              value="pdf"
              control={<Radio />}
              label="pdf"
              disabled={
                props.reportInfo.viewEditStatus === "VIEW" ? true : false
              }
            />
          </RadioGroup>
        </FormControl>
      </div>

      {/* Report File Name Format */}

      <div className="form right-side input-div">
        <TextField
          label="File Name format:"
          id="report_FileName_Format"
          placeholder="Enter desire format for File Name"
          onChange={addFileNameFormat}
          onFocus={viewOnlyNotifucation}
          sx={{ m: 1, width: "75%" }}
          InputProps={{
            readOnly: props.reportInfo.viewEditStatus === "VIEW" ? true : false,
            startAdornment: <InputAdornment position="start"></InputAdornment>,
          }}
          value={
            ReportInfo.fileNameFormat === null ||
            ReportInfo.fileNameFormat === ""
              ? (ReportInfo.fileNameFormat =
                  "MMM " + ReportInfo.name + " dd HH-mm-ss")
              : ReportInfo.fileNameFormat
          }
          helperText="It's File Name format for your dump report for eg: MMM 'reportName' dd HH-mm-ss {}"
        />
      </div>
    </div>
  );
  

  const nameError =
    ArrayUtils.isNotEmpty(props.validationErrors) &&
    props.validationErrors
      .filter((error) => error.property === "nameError")
      .map((error) => error.message)[0];
  const descriptionError =
    ArrayUtils.isNotEmpty(props.validationErrors) &&
    props.validationErrors
      .filter((error) => error.property === "descriptionError")
      .map((error) => error.message)[0];
  const ownerError =
    ArrayUtils.isNotEmpty(props.validationErrors) &&
    props.validationErrors
      .filter((error) => error.property === "ownerError")
      .map((error) => error.message)[0];
  const fetchLimitError =
    ArrayUtils.isNotEmpty(props.validationErrors) &&
    props.validationErrors
      .filter((error) => error.property === "fetchLimitError")
      .map((error) => error.message)[0];

  useEffect(() => {
    if (fetchLimitError) {
      setShow(true);
    }
  }, [fetchLimitError]);

  useEffect(() => {
    const owner = getNameFromEmail(false);
    getUserList(authContext).then((data) => {
      data.map((user: any) => {
        user["label"] = user.fullname;
        user["value"] = user.username;
        return user;
      });
      const ownerOption = owner ? getOwnerName(owner,data) : [];
      setOwners([{ value: " ", label: "Select Owner Name" },...ownerOption, ...data]);
    });
  }, [owner]);
  function getOwnerName(ownerName: string, userList: any[]) {
    const firstName = ownerName.split(' ')[0];
    const matchedUser = userList.find((user) =>
      user.label.split(' ')[0] === firstName
    );
    if (matchedUser) {
      const { username, label } = matchedUser;
      setOwner(username);
      ReportInfo.owner = username;
      return [{ label, value: username }];
    }
    return [{ label: ownerName, value: ownerName }];
  }

  const viewOnlyNotifucation = () => {
    if (props.reportInfo.viewEditStatus === "VIEW" ? true : false)
      popNotification("Oops!", "You are in View Mode", "blue", <X />);
  };
  return (
    <div
      className="form-group-report wizard-content-card"
      style={{ height: "100%" }}
    >
      {/* Report Name */}

      <div className="full-width">
        <div className="input-div">
          <TextField
            label="Report Name:"
            onChange={addReportName}
            value={ReportInfo.name === null ? "" : ReportInfo.name}
            id="report_name"
            placeholder="Enter Report Name"
            sx={{ m: 1, width: "75%" }}
            onFocus={viewOnlyNotifucation}
            InputProps={{
              readOnly:
                props.reportInfo.viewEditStatus === "VIEW" ? true : false,
              startAdornment: (
                <InputAdornment position="start"></InputAdornment>
              ),
            }}
          />
          {/* <label htmlFor="user_name" className="form-label">Report Name:</label>
                  <input type="text" className={"report-form-field"} placeholder="Enter Report Name" required id="user_name"/> */}
          {nameError && <Text color="red">{nameError}</Text>}
        </div>
      </div>

      {/* Report Description */}

      <div className="full-width">
        <div className="input-div">
          <TextField
            label="Report Description:"
            onChange={addReportDescription}
            value={
              ReportInfo.description === null ? "" : ReportInfo.description
            }
            id="report_description"
            placeholder="Enter description of Report"
            sx={{ m: 1, width: "75%" }}
            onFocus={viewOnlyNotifucation}
            InputProps={{
              readOnly:
                props.reportInfo.viewEditStatus === "VIEW" ? true : false,
              startAdornment: (
                <InputAdornment position="start"></InputAdornment>
              ),
            }}
          />
          {descriptionError && <Text color="red">{descriptionError}</Text>}
        </div>
      </div>

      {/* Owner Name */}

      <div className="full-width">
        <div className="input-div">
          <TextField
            id="owner"
            select
            label="Owner:"
            value={props.reportInfo.viewEditStatus === "VIEW" ? ReportInfo.owner : owner}
            onChange={addReportOwnerName}
            sx={{ m: 1, width: "75%" }}
            SelectProps={{
              readOnly:
                props.reportInfo.viewEditStatus === "VIEW" ? true : false,
              native: false,
            }}
            placeholder="Select Owner Name"
            onFocus={viewOnlyNotifucation}
            helperText="Select your beanstalk Name"
          >
            {owners.map((option: any) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>

          {ownerError && <Text color="red">{ownerError}</Text>}
        </div>
      </div>
      {/* Report Type Select */}

      <div className="full-width">
        <div className="input-div select">
          <TextField
            id="report_type"
            select
            label="Report Type:"
            value={option}
            onChange={addReportType}
            sx={{ m: 1, width: "75%" }}
            SelectProps={{
              readOnly:
                props.reportInfo.viewEditStatus === "VIEW" ? true : false,
              native: false,
            }}
            placeholder="Select Report Type"
            onFocus={viewOnlyNotifucation}
            helperText="Select desired Report Type eg: Entity If Data required from entity"
          >
            {options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </div>
      </div>
      <div className="full-width">
        <Box
          id="toggle_text"
          onClick={() => setShow(!show)}
          style={{ marginRight: "11%", textAlign: "right" }}
        >
          {addShow()}
          <Icon color="primary">{/* <AddRoundedIcon/> */}</Icon>
        </Box>
        {show ? (
          <Grow
            in={show}
            style={{ transformOrigin: "0 0 0" }}
            {...(show ? { timeout: 1000 } : {})}
          >
            {additonalInfo(ReportInfo)}
          </Grow>
        ) : null}
      </div>
    </div>
  );
}
